import Axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import Pagination from '../components-contabilidad-analisis/Pagination'
import { fetchApi } from "../tools" // Consumir api
import ResultadoDataGrid from './CustomDataGrid'
import { sendId } from '../reinscripciones/services/reinscripciones.service'
import { Field, Form, Formik } from 'formik'
import LoadingGrid from '../perfil-alumno/components/LoadingGrid'

const BusquedaAlumnos = ({
    isRetiro,
    mainURL = '',
    setEstado,
    setHayCupo,
    hayCupo,
    showDialogoPlan4,
    isPagos = false,
    url,
    headers,
    setModal,
    metodo,
    opcion,
    campos,
    columnas,
    titulo,
    subtitulo,
    seleccion,
    setClose = () => { },
    setResponse = () => { },
    setopcionSelect = () => { },
    Idsede = '',
    Sede = '',
    nombreAlumno = '',
    handleClick,
    reg_pag = 5,
    IdCiclo = 0,
    handleAlumnoCta,
    dataAlumnos = [],
    setTextoBusqueda,
    flagSearch,
    resetSearch = false,
    setresetForm,
    isGrid = false,
    setIsGrid,
    traslado = 0,
    handleInicio=()=>{},
    perfil,
    setFlagSearch,
    //resetBusqueda = true
}) => {
    // selection true para que permita seleccionar un registro, false para que no permita seleccionar un registro
    const [alumnos, setAlumnos] = useState([])
    const [dataLength, setDataLength] = useState(0);
    const [paramSede, setparamSede] = useState(Sede);
    const [loading, setLoading] = useState(false);
    const busquedaRef = useRef()

    const mostrarDialogo = (mensaje) => {
        //condicion para mostrarse
        if (dataLength === 0) {
            setModal({
                show: true,
                ok: false,
                msg: mensaje
            })
        }
    }

    const ocultarDialogo = () => {
        setModal({
            show: false,
            ok: true,
            msg: ''
        })
    }

    useEffect(() => {
      
    console.log('cambiado el flag')
    busquedaRef.current.focus()
    }, [flagSearch])
    

    useEffect(() => {
      
    console.log('loading...', loading)
    
    }, [loading])

    useEffect(() => {
        console.log('cambio en data alumnos')
        if (dataAlumnos.length > 0) {
            setAlumnos(dataAlumnos)
        } else {
            
            console.log('no mayor a cero')
            if (resetSearch) {
                setresetForm(false)
                console.log('reset search')
            }
            if (isGrid) {
                console.log('is grid')
                setIsGrid(false)
                setAlumnos([])
                
            }
        }
    }, [dataAlumnos, resetSearch])

    useEffect(() => {
        if (Sede !== undefined && Sede !== '' && Sede !== false && Sede !== null) {
            setparamSede(Sede)
        }
    }, [Sede])

    const fetchData = async (params, resetForm) => {
        setDataLength(0)
        try {            
            setLoading(true)
            const res = await fetchApi({
                url,
                headers,
                content: params
            })

            if (res.length > 0) {
                //console.log(res)
                setAlumnos(res)
                setDataLength(res.length)
                ocultarDialogo()
                setLoading(false)
            } else {
                setLoading(false)
                mostrarDialogo('Sin resultados, intente de nuevo.')
                setAlumnos([])
                setTimeout(() => {
                    
                    //if(!perfil)resetForm();
                    ocultarDialogo();
                    setTextoBusqueda(() => '') // para resetear el texto
                }, "2000")
            }
        } catch (err) {
            resetForm()
            mostrarDialogo()
            setLoading(false)
            //console.log(err)
        }
    }

    //Paginación
    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = reg_pag

    const indexOfLastRecord = currentPage * recordsPerPage
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage

    const currentRecords = alumnos?.slice(indexOfFirstRecord, indexOfLastRecord)

    const nPages = Math.ceil(alumnos?.length / recordsPerPage)
    //Fin paginación

    const handleChange = (e, name, flag, resetForm, setInnerFieldValue) => {
        console.log('cambiando...')
        //handleInicio(e.target.value)
        if (flagSearch !== undefined && flagSearch !== '' && flagSearch !== false && flagSearch !== null) {
            flag = flagSearch
        }

        setInnerFieldValue(name, e.target.value);

        if (e.target.value.trim() === '') {
            setDataLength(0)
            setAlumnos([])
            setAlumnos(dataAlumnos)
        } else {
            const params = {
                [opcion]: metodo,
                [Idsede]: paramSede, //modiicacion, tambien se modificaron las importaciones de estos campos
                'idciclo': IdCiclo,
                'Traslado': traslado
            }

            if (flag !== 'Carnet') {
                if (!e.target.value || e.target.value.length < 3) {
                    setDataLength(0)
                    return;
                }

                if (setTextoBusqueda !== undefined) {
                    setTextoBusqueda(e.target.value.trim())
                }
                params[flag] = e.target.value.trim();
                setTimeout(fetchData(params, resetForm), 1000)
                setCurrentPage(1);
            }

            if (flag === 'Carnet' && e.target.value.length >= 12) {
                //(e.target.value.substring(0, 12), 'carnet search')
                setInnerFieldValue(flag, e.target.value.substring(0, 12));
                params[flag] = e.target.value.substring(0, 12)

                setTimeout(fetchData(params, resetForm), 1000)
                setCurrentPage(1);
                return;
            }
        }
    }

    const handleFocus = (e, flag, resetForm) => {

        if (flagSearch !== undefined && flagSearch !== '' && flagSearch !== false && flagSearch !== null) {
            flag = flagSearch
        }

        if (e.target.value.trim() === '') {
            setDataLength(0)
            setAlumnos([])
        } else {

            const params = {
                [opcion]: metodo,
                [Idsede]: paramSede, //modiicacion, tambien se modificaron las importaciones de estos campos
                'idciclo': IdCiclo
            }

            if (flag !== 'Carnet') {
                if (!e.target.value || e.target.value.length < 3) {
                    setDataLength(0)
                    return;
                }

                if (setTextoBusqueda !== undefined) {
                    setTextoBusqueda(e.target.value.trim())
                }
                params[flag] = e.target.value.trim();
                setTimeout(fetchData(params, resetForm), 1000)
                setCurrentPage(1);
            }

            if (flag === 'Carnet' && e.target.value.length >= 12) {

                if (setTextoBusqueda !== undefined) {
                    setTextoBusqueda(e.target.value.substring(0, 12))
                }

                params[flag] = e.target.value.substring(0, 12)

                setTimeout(fetchData(params, resetForm), 1000)
                setCurrentPage(1);
                return;
            }
        }
    }

    const handleAlumno = async (alumno, text) => {
        if (text === "Seleccionar" && mainURL) {
            const respuesta = await sendId(alumno.id, fetchApi, headers, mainURL) // estado, mensaje
            // console.log(respuesta[0])
            if (respuesta[0]) {
                setHayCupo(true)
                setDataLength(0)
                setClose(true)
                setResponse(alumno)
                setopcionSelect(text)
                handleAlumnoCta(alumno)
            } else {
                setHayCupo(false)
                setModal({
                    show: true,
                    ok: false,
                    msg: respuesta[1]
                })
            }
        } else {
            setDataLength(0)
            setClose(true)
            setResponse(alumno)
            setopcionSelect(text) 
            handleAlumnoCta(alumno)
        }


    }

    const handleOptionChange = (stringParam, resetForm, values) => {
        console.log(values)
        setFlagSearch(stringParam)
        resetForm()
        //setTextoBusqueda("")
    }

    return (
        <>
            <Formik
                initialValues={
                    {
                        Alumno: '',
                        Carnet: ''
                    }
                }
            >
                {({ setFieldValue: setInnerFieldValue, values, resetForm }) => {

                    if (resetSearch) {

                        values.Alumno = ''
                    }
                    return (
                        <>
                            <div>
                                {perfil ? //|| !resetBusqueda
                                <div className="">
                                  <p className="text-white m-2" >Buscar por</p>
                                  <label className="text-white m-2" htmlfor="Carnet">Carnet</label>                          
                                  <input type="radio" checked={flagSearch === "Carnet"}        name={"Carnet"} onChange={() => handleOptionChange("Carnet", resetForm, values)}/>
                                  <label className="text-white m-2" htmlfor="Aspirante">Nombre</label>
                                  <input type="radio" checked={flagSearch === "Aspirante"}  name={"Aspirante"} onChange={() => handleOptionChange("Aspirante", resetForm, values)}/>
                                </div>
                                :
                                null
                                }
                                <div className='grid grid-cols-2 gap-1'>
                                    {campos?.map(({ name, type, position, flag, id }) =>
                                        <div key={id} className={position}>
                                            <label className="block text-sm font-medium text-grisMira">
                                                {perfil? "Debe ingresar nombre o carnet para realizar la búsqueda": name}
                                            </label>
                                            <Field
                                                name={name}
                                                innerRef={(f) => busquedaRef.current = f}
                                                // onBlur={(e) => handleFocus(e, flag, resetForm)}
                                                onChange={(e) => handleChange(e, name, flag, resetForm, setInnerFieldValue)}
                                                type={type}
                                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )
                }}
            </Formik >
            <div className='gap-1'>
                {loading?
                <LoadingGrid
                headers={headers}
                columnas={columnas}
                reg_pag={reg_pag}
                titulo={titulo}
                subtitulo={subtitulo}
                >

                </LoadingGrid>:
                <ResultadoDataGrid 
                    isRetiro={isRetiro}
                    handleClick={handleClick}
                    alumnos={alumnos.length > 0 ? currentRecords : []}
                    handleAlumno={handleAlumno}
                    columnas={columnas}
                    titulo={titulo}
                    subtitulo={subtitulo}
                    perfil={perfil}
                    seleccion={seleccion}
                    handleAlumnoCta={handleAlumnoCta}
                    isPagos={isPagos}
                    showDialogoPlan4={showDialogoPlan4}
                    setEstado={setEstado}
                    traslado={traslado}
                />
               }
            </div>
            <Pagination
                nPages={nPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={alumnos?.length}
                indexOfFirstRecord={indexOfFirstRecord}
                indexOfLastRecord={indexOfLastRecord}
            />
        </>
    )
}

export default BusquedaAlumnos